// extracted by mini-css-extract-plugin
module.exports = {"card":"ContactCard_card_3avDy","companyName":"ContactCard_companyName_2_L1F","name":"ContactCard_name_s5W5T","email":"ContactCard_email_31K-8"};